export default function uint8ArrayToString(uint8Array?: Uint8Array | null): string {
  return uint8Array ? new TextDecoder().decode(uint8Array) : '';
}